module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("7")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Mein Lied")]), _vm._v(" hat seines\nSchmuckes sich"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nentäußert, es ist nicht stolz auf Kleid"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nund Zier. Der Schmuck könnt unsre"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nEinigkeit zerstören, er würde zwischen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndich und mich sich stellen; dein Flüstern"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nkönnt ertrinken in dem Klingklang.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mein Dichterhochmut stirbt in Scham"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nvor deinem Anblick, o Meisterdichter,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nich saß dir zu Füßen. Laß mich mein"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nLeben grad und einfach machen, gleich"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\neiner Flöte, die du füllst mit Tönen. "), _c('a', {
    attrs: {
      "id": "page10",
      "title": "wedi/cal"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a58ec006","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0008.vue
// module id = 78
// module chunks = 0